import React from 'react';
import DemoBillsList from './DemoBillsList';

const DemoBill = () => {
  return <DemoBillsList />;
};

export default DemoBill;
